(() => {
  if (customElements.get("animated-quote")) {
    return;
  }

  class AnimatedQuote extends HTMLElement {
    constructor() {
      super();
      this.selector = {
        section: '.section-animated-quote',
        word: '.section-animated-quote [data-word]',
        image: '.section-animated-quote .section__image img'
      };

      gsap.registerPlugin(ScrollTrigger)
      this.animateQuote();
    }

    animateQuote() {
      gsap.to(this.selector.word, {
        scrollTrigger: {
          trigger: this.selector.section,
          start: "50% 50%",
          end: "+=150%",
          pin: true,
          scrub: 1,
          invalidateOnRefresh: true,
        },
        opacity: 1,
        stagger: 0.2,
        duration: 1,
      });

      gsap.from(this.selector.image, {
        scrollTrigger: {
          trigger: this.selector.section,
          start: "50% 50%",
          end: "+=150%",
          scrub: 1,
        },
        opacity: 0,
        scale: 1.1,
      });

      let resizeTimeout;
      const resizeObserver = new ResizeObserver(() => {
        clearTimeout(resizeTimeout);

        resizeTimeout = setTimeout(() => {
          ScrollTrigger.refresh(true);
        }, 300);
      });

      resizeObserver.observe(document.body);
    }
  }

  customElements.define("animated-quote", AnimatedQuote);
})();
